/**
 * Réordonne une liste de questions pour qu'un même item (même lettre, même
 * mot...) ne revienne jamais deux fois d'affilée. Utilisé par
 * PracticeAlphabet ET le Daily Plan — pour ne jamais diverger.
 */
export function makeStrictSequence(arr) {
  if (!arr || arr.length === 0) return [];
  const result = [];
  const remaining = [...arr];
  result.push(remaining.shift());
  while (remaining.length > 0) {
    const lastAdded = result[result.length - 1];
    const lastId = lastAdded.key || lastAdded.char || lastAdded.prompt;
    const index = remaining.findIndex(
      (q) => (q.key || q.char || q.prompt) !== lastId,
    );
    if (index !== -1) {
      result.push(remaining[index]);
      remaining.splice(index, 1);
    } else break;
  }
  return result;
}
